import { useLiveWireStore } from "@/stores/livewire";

function AccuracyTodayWidget() {

  const accuracy = useLiveWireStore((state) => state.daily?.accuracy || 0);

  return (
    <div className="accuracy-today widget widget-md">
      <div className="card card-rounded">
        <div className="d-flex justify-content-between p-3">
          <div>
            <span className="bi bi-bullseye text-orange me-2 fs-24"></span>
            <span className="text-black fw-bold fs-18">Accuracy Today</span>
          </div>
          <div className="px-2 py-1 fw-bold"></div>
        </div>
        <div className="card-body pt-0 text-dark d-flex justify-content-center align-items-center">
          <div className="widget-value success">{Math.round(accuracy)}%</div>
        </div>
      </div>
    </div>
  );
}

export default AccuracyTodayWidget;
